import { Icon } from './icons'

const SECTIONS = [
  { id: 'conversas', label: 'Conversas', icon: 'chat' },
  { id: 'clientes', label: 'Clientes', icon: 'user' },
  { id: 'pedidos', label: 'Pedidos', icon: 'box' },
  { id: 'tickets', label: 'Tickets', icon: 'ticket' },
  { id: 'relatorios', label: 'Relatórios', icon: 'chart' },
  { id: 'ia', label: 'IA', icon: 'spark' },
  { id: 'robos', label: 'Robôs', icon: 'robot' },
] as const

/** Só admin. A API devolve 403 para o resto, e oferecer um botão que nega é pior que não ter. */
const ADMIN_SECTIONS = [
  { id: 'registro', label: 'Registro', icon: 'list' },
  { id: 'cordialidade', label: 'Cordialidade', icon: 'smile' },
] as const

export function Rail({
  section,
  onSection,
  isAdmin,
  pendingLinks = 0,
}: {
  section: string
  onSection: (s: string) => void
  isAdmin: boolean
  /** Pedidos de liberação de link esperando o gestor — um ponto na engrenagem. */
  pendingLinks?: number
}) {
  return (
    <nav className="rail">
      <div className="logo">Q</div>
      {[...SECTIONS, ...(isAdmin ? ADMIN_SECTIONS : [])].map((s) => (
        <button
          key={s.id}
          className={`rail-btn ${section === s.id ? 'on' : ''}`}
          onClick={() => onSection(s.id)}
        >
          <Icon name={s.icon} />
          <span className="tip">{s.label}</span>
        </button>
      ))}
      <div className="rail-sp" />
      <button
        className={`rail-btn ${section === 'config' ? 'on' : ''}`}
        onClick={() => onSection('config')}
        title={pendingLinks ? `${pendingLinks} pedido(s) de liberação de link` : undefined}
      >
        <Icon name="gear" />
        {pendingLinks > 0 && <span className="rail-dot" />}
        <span className="tip">Configurações</span>
      </button>
    </nav>
  )
}
